// Footer "Cookie Settings" on /sport (CDN-1654). footer.php keeps the CookieYes
// class on every page and adds data-tvk-consent="inmobi" on /sport URLs. Decide at
// click time: with the InMobi TCF API on the page, open its UI and stop CookieYes;
// without it, do nothing and CookieYes handles the click.
// Capture phase on document: runs before CookieYes's listener on the link itself.
document.addEventListener(
  "click",
  (event) => {
    const link = event.target instanceof Element ? event.target.closest("[data-tvk-consent='inmobi']") : null;
    if (!link || typeof window.__tcfapi !== "function") return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.__tcfapi("displayConsentUi", 2, function () {});
  },
  true
);
